import { Box } from '@/shared/ui';
import { DisplaySettingsIcon } from '@/shared/ui/icons';

import type { CatalogItem } from '@/entities/catalog-item';
import Button from '@/shared/ui/primitives/Button';
import getActiveColumnCount from './getActiveColumnCount';

import type { Table } from '@tanstack/react-table';

const DisplaySettingsButton = ({
  table,
  open,
  onToggle
}: {
  table: Table<CatalogItem>;
  open: boolean;
  onToggle: () => void;
}) => {
  const activeColumnCount = getActiveColumnCount(table);

  return (
    <Button
      aria-expanded={open}
      size='small'
      sx={{ width: 171, height: 32, px: 1, justifyContent: 'flex-start', whiteSpace: 'nowrap' }}
      variant='outlined'
      onClick={onToggle}
    >
      <DisplaySettingsIcon sx={{ mr: 1 }} />
      Display settings
      {activeColumnCount > 0 && (
        <Box
          data-testid='display-settings-badge'
          sx={{
            ml: 1,
            backgroundColor: 'gx.highlight',
            color: '#fff',
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: 1,
            px: '4px',
            py: '2px',
            display: 'inline-flex',
            alignItems: 'center'
          }}
        >
          {activeColumnCount}
        </Box>
      )}
    </Button>
  );
};

export default DisplaySettingsButton;
